import { useRef, useState } from 'react'

import { UnsavedChangesCloseGuard } from 'ui/components/GenericUnsavedChangesModal/GenericUnsavedChangesModal'

/*
 * For use with the GenericUnsavedChangesModal. Allows for a model to be opened and closed with a close guard.
 * Usage:
 *
 * ```
 * const { isOpen, onOpenChange, closeGuardRef } = useModelOpenStateWithCloseGuard()
 * <Modal open={isOpen} onOpenChange={onOpenChange}>
 *     <ModalContent>
 *         <GenericUnsavedChangesModal ref={closeGuardRef} />
 *     </ModalContent>
 * </Modal>
 * ```
 */
export function useModelOpenStateWithCloseGuard() {
    const [isOpen, setIsOpen] = useState(false)
    const closeGuardRef = useRef<UnsavedChangesCloseGuard>(null)

    const onOpenChange = async (value: boolean) => {
        if (!value && closeGuardRef.current) {
            const result = await closeGuardRef.current.tryClose()
            if (result) {
                setIsOpen(false)
            }
        } else {
            setIsOpen(value)
        }
    }

    return {
        isOpen,
        setIsOpenUnguarded: setIsOpen,
        onOpenChange,
        closeGuardRef,
    }
}
